import { ArrowDown, ArrowUp, BringToFront, SendToBack } from 'lucide-react'
import type { ArrangeOp } from '../types/layout-operations'
import { TooltipIconButton } from './tooltip-icon-button'

/** The four Arrange buttons, in on-screen order. `up` ops need `canBringUp`, the rest `canSendDown`. */
const ARRANGE_TOOLS = [
  { op: 'bringToFront', label: 'Bring to Front', Icon: BringToFront, up: true },
  { op: 'bringForward', label: 'Bring Forward', Icon: ArrowUp, up: true },
  { op: 'sendBackward', label: 'Send Backward', Icon: ArrowDown, up: false },
  { op: 'sendToBack', label: 'Send to Back', Icon: SendToBack, up: false },
] as const

interface ArrangeButtonsProps {
  canBringUp: boolean
  canSendDown: boolean
  onArrange: (op: ArrangeOp) => void
}

export function ArrangeButtons({ canBringUp, canSendDown, onArrange }: ArrangeButtonsProps) {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-foreground leading-none">Arrange</label>
      <div className="flex gap-1.5 mt-2">
        {ARRANGE_TOOLS.map(({ op, label, Icon, up }) => {
          const enabled = up ? canBringUp : canSendDown

          return (
            <TooltipIconButton
              key={op}
              tooltip={label}
              aria-label={label}
              disabled={!enabled}
              onPointerDown={(e) => {
                if (!enabled) {
                  return
                }

                e.preventDefault()
                e.stopPropagation()
                onArrange(op)
              }}
              className="text-muted-foreground"
            >
              <Icon className="h-4 w-4" aria-hidden />
            </TooltipIconButton>
          )
        })}
      </div>
    </div>
  )
}
